import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import ShiftListTable from './Components/ShiftListTable'

const ShiftList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Shift List</HeadingOne>
                    <AddItemBtn url="add-shift" title="Create" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <ShiftListTable />
            </div>
        </PageBody>
    )
}

export default ShiftList
